import MetaService from 'services/MetaService'

export async function fetchMetaData() {
  const result = await MetaService.getMetaData()
  return result
}
